import { Measure } from '../../api/work-periods-client/work-periods-client.type';
import {
  graphAmethyst,
  graphButterscotch,
  graphCambridgeBlue,
  graphChefchaouenBlue,
  graphLightRed,
  graphPictonBlue,
  graphSandyBrown,
  graphTropicalIndigo,
  graphVerdigris,
  graphSunglow,
} from '../../styles/design-tokens';

/**
 * List of deprecated measures that should be excluded from the UI.
 *
 * @constant {Measure[]} DEPRECATED_MEASURES
 */
const DEPRECATED_MEASURES: Measure[] = [
  Measure.WorkloadDistributionCapacity,
  Measure.ScopeCreep,
  Measure.FlowByPace,
  Measure.FlowByPhase,
];

/**
 * List of measures that require special transformer handling.
 * These measures need the TimeAllocationValuesOnly transformer when fetching data.
 *
 * @constant {Measure[]} TRANSFORMER_MEASURES
 */
const TRANSFORMER_MEASURES: Measure[] = [Measure.DeclinedChangeRequests, Measure.ReviewTime, Measure.Readiness];

/**
 * List of measures that are used as key measures on the UI and are selected by default.
 *
 * @constant {Measure[]} KEY_MEASURES
 */
const KEY_MEASURES: Measure[] = [Measure.Throughput, Measure.Velocity, Measure.CycleTime, Measure.ReactionTime];

/**
 * Array of colors used for charts and visualizations.
 * These colors are used consistently across different chart types to maintain visual coherence.
 * The first four entries are the original palette — append only, so existing
 * charts with up to four series keep their established colors; the extras
 * kick in for many-series charts (e.g. cycle time by model family).
 *
 * @constant {string[]} CHART_COLORS
 */
const CHART_COLORS = [
  graphTropicalIndigo,
  graphLightRed,
  graphPictonBlue,
  graphSandyBrown,
  graphChefchaouenBlue,
  graphCambridgeBlue,
  graphAmethyst,
  graphButterscotch,
  graphVerdigris,
  graphSunglow,
];

/**
 * List of measures that should be aggregated using sum instead of average.
 * These measures represent totals that should add up across entities.
 *
 * @constant {Measure[]} SUM_TYPE_MEASURES
 */
const SUM_TYPE_MEASURES: Measure[] = [Measure.Throughput];

export { CHART_COLORS, DEPRECATED_MEASURES, KEY_MEASURES, SUM_TYPE_MEASURES, TRANSFORMER_MEASURES };
